import { TrackingService } from './TrackingService'

declare global {
  var __trackingService: TrackingService | undefined
}

export const getTrackingService = (): TrackingService => {
  globalThis.__trackingService ??= TrackingService.getInstance()
  return globalThis.__trackingService
}
